import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardFooter,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row } from 'reactstrap';

class Videos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const closeBtn = <button className="close" onClick={this.toggle}>&times;</button>;

    return (
      <div className="tab-videos">

        <Row className="mb-4 align-items-center">
          <Col>
            <h3 className="mb-md-0 text-center text-md-left">Merchant Videos</h3>
            <p className="mb-0 text-center text-md-left">Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod.</p>
          </Col>
        </Row>

        <Row>
          <Col sm={6} md={4} lg={3}>
            <Card className="video-card" tag={Link} to="#" onClick={this.toggle}>
              <div className="video-thumb" style={{backgroundImage: 'url(images/video1-lg.jpg)'}} />
              <CardFooter className="py-2">
                <h5 className="mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="video-card" tag={Link} to="#" onClick={this.toggle}>
              <div className="video-thumb" style={{backgroundImage: 'url(images/video2-lg.jpg)'}} />
              <CardFooter className="py-2">
                <h5 className="mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="video-card" tag={Link} to="#" onClick={this.toggle}>
              <div className="video-thumb" style={{backgroundImage: 'url(images/video3-lg.jpg)'}} />
              <CardFooter className="py-2">
                <h5 className="mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="video-card" tag={Link} to="#" onClick={this.toggle}>
              <div className="video-thumb" style={{backgroundImage: 'url(images/video1-lg.jpg)'}} />
              <CardFooter className="py-2">
                <h5 className="mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="video-card" tag={Link} to="#" onClick={this.toggle}>
              <div className="video-thumb" style={{backgroundImage: 'url(images/video1-lg.jpg)'}} />
              <CardFooter className="py-2">
                <h5 className="mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="video-card" tag={Link} to="#" onClick={this.toggle}>
              <div className="video-thumb" style={{backgroundImage: 'url(images/video2-lg.jpg)'}} />
              <CardFooter className="py-2">
                <h5 className="mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="video-card" tag={Link} to="#" onClick={this.toggle}>
              <div className="video-thumb" style={{backgroundImage: 'url(images/video3-lg.jpg)'}} />
              <CardFooter className="py-2">
                <h5 className="mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="video-card" tag={Link} to="#" onClick={this.toggle}>
              <div className="video-thumb" style={{backgroundImage: 'url(images/video1-lg.jpg)'}} />
              <CardFooter className="py-2">
                <h5 className="mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
        </Row>

        <Row className="mt-md-2 mb-2">
          <Col>
            <Pagination aria-label="Page navigation example">
              <PaginationItem disabled><PaginationLink previous href="#" /></PaginationItem>
              <PaginationItem active><PaginationLink href="#">1</PaginationLink></PaginationItem>
              <PaginationItem><PaginationLink href="#">2</PaginationLink></PaginationItem>
              <PaginationItem><PaginationLink href="#">3</PaginationLink></PaginationItem>
              <PaginationItem><PaginationLink href="#">4</PaginationLink></PaginationItem>
              <PaginationItem><PaginationLink next href="#" /></PaginationItem>
            </Pagination>
          </Col>
        </Row>

        <Modal isOpen={this.state.modal} toggle={this.toggle} size="xl">
          <ModalHeader toggle={this.toggle} close={closeBtn}>[[Merchant Video Title]]</ModalHeader>
          <ModalBody className="p-0">
            <div className="video-wrapper">
              <iframe title="merchantVideo" src="https://www.youtube.com/embed/d544miNYipU" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
          </ModalBody>
        </Modal>

      </div>
    )
  }
}

export default Videos;
